import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { AccountContent } from "../accountContent.js";

/**
 * The Account page, showroom layout: the header card, the
 * tabs under it, any notices, then the tab showing. Settings puts its sub-tabs over its panel.
 * One column at every width; the panels lay out their own insides.
 */
export function AccountShowroomLayout({ sections }: PageLayoutProps<AccountContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8">
      {sections.header}
      <div className="flex flex-col gap-4">
        {sections.tabs}
        {sections.notices}
      </div>
      <div className="flex flex-col gap-4 md:gap-6">
        {sections.settingsNav}
        {sections.profile}
        {sections.shipping}
        {sections.verification}
        {sections.advanced}
        {sections.history}
      </div>
    </Section>
  );
}
